import type { BudgetRequestMessage } from '../../../../types/BudgetMessage';
import type { VesselMessage } from '../../../../types/VesselMessage';

import type { VesselBudgetFormValues } from './BudgetForm';

export const createVesselBudgetRequest = (
    values: VesselBudgetFormValues,
    vessel: Pick<VesselMessage, 'id' | 'customerId'>
): BudgetRequestMessage => ({
    budget: { amount: Number(values.budget.amount), currency: 'USD' },
    startDate: values.startDate,
    vesselId: vessel.id,
    customerId: vessel.customerId,
});
